import React from 'react';
import _ from 'lodash';
import {
  FormControl,
  Button,
  Box,
  Typography
} from '@mui/material';
import { useMutation, useQuery } from 'react-fetching-library';
import EmailEditor, { EditorRef, EmailEditorProps } from 'react-email-editor';
import { uploadFormSchemaAction, getJsonFormsAction } from '../../services/request';
import JsonFormSchemaUpload from './JsonFormSchemUpload';
import JsonFormsList from './JsonFormsList';

export const FormSchemaUploadPanel = () => {
  const emailEditorRef = React.useRef(null);
  const { mutate } = useMutation(uploadFormSchemaAction);
  const { loading, error, payload } = useQuery(getJsonFormsAction());
  const [forms, setForms] = React.useState([]);
  const [fileData, setFileData] = React.useState(null);
  const [fileContent, setFileContent] = React.useState(null);
  const [responseMessage, setResponseMessage] = React.useState('');

  const handleFileSelect = e => {
    setFileData(e.target.files[0]);
    const r = new FileReader();
    r.readAsText(e.target.files[0]);
    r.onload = e => {
      setFileContent(e.target.result);
    };
  };

  const handleSubmit = async() => {
    const { error, payload } = await mutate({ json_data: fileContent });
    console.log(payload);
    if (!error) {
      setResponseMessage('Wgrano formularz');
    } else {
      console.log(payload);
      setResponseMessage(payload.message);
    }
  };

  React.useEffect(() => {
    if (!loading && !error) {
      setForms(payload.results);
    }
  }, [loading]);

  const exportHtml = () => {
    const unlayer = emailEditorRef.current?.editor;

    unlayer?.exportHtml(data => {
      const { design, html } = data;
      console.log('exportHtml', html);
    });
  };

  const onReady = unlayer => {
    // editor is ready
    // you can load your template here;
    // the design json can be obtained by calling
    // unlayer.loadDesign(callback) or unlayer.exportHtml(callback)

    // const templateJson = { DESIGN JSON GOES HERE };
    // unlayer.loadDesign(templateJson);
  };

  return (
    <Box>
      <Typography variant="subtitle1">Stare Formularze:</Typography>
      <FormControl>
        <Button variant="contained" component="label">
          Wczytaj plik
          <input type="file" hidden onChange={e => handleFileSelect(e)} />
        </Button>
        <Typography
          style={{ wordWrap: 'break-word', overflow: 'hidden' }}
          // noWrap
          variant="caption"
          align="center"
        >
          {!_.isNull(fileData) ? fileData.name : ''}
        </Typography>
      </FormControl>
      <Button
        disabled={_.isNull(fileContent)}
        color="primary"
        variant="contained"
        onClick={() => handleSubmit()}
      >
        Zapisz
      </Button>
      <p>{responseMessage}</p>
      <JsonFormSchemaUpload setForms={setForms}/>
      <JsonFormsList forms={forms} setForms={setForms}/>
    </Box>
  );
};
